export interface HslBusesConfig {
  stopId: string;
  walkMinutes: number;
  leaveBufferMinutes: number;
}

export const DEFAULT_HSL_BUSES_CONFIG: HslBusesConfig = {
  stopId: '1431102',
  walkMinutes: 7,
  leaveBufferMinutes: 2,
};

export function mergeHslBusesConfig(partial: Partial<HslBusesConfig> | null | undefined): HslBusesConfig {
  const p = partial ?? {};
  const stopId = typeof p.stopId === 'string' && p.stopId !== '' ? p.stopId : DEFAULT_HSL_BUSES_CONFIG.stopId;
  const walkMinutes =
    typeof p.walkMinutes === 'number' && Number.isFinite(p.walkMinutes) && p.walkMinutes >= 0
      ? p.walkMinutes
      : DEFAULT_HSL_BUSES_CONFIG.walkMinutes;
  const leaveBufferMinutes =
    typeof p.leaveBufferMinutes === 'number' && Number.isFinite(p.leaveBufferMinutes) && p.leaveBufferMinutes >= 0
      ? p.leaveBufferMinutes
      : DEFAULT_HSL_BUSES_CONFIG.leaveBufferMinutes;
  return { stopId, walkMinutes, leaveBufferMinutes };
}
